export default __webpack_public_path__ + "static/media/suit1.e087fc45.png";